module.exports = __webpack_public_path__ + "static/media/highlighter.09507c35.svg";